import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlpathService {

  constructor() {
   
   }
   public baseBackendUrlDev =  environment.apiUrl;
   public baseBackendUrlProd =  'https://api-natfood-b2a0ebfmcrdkbva2.eastus2-01.azurewebsites.net/api/';

   // public baseBackendUrl =  'http://127.0.0.1:8000/api/';
}
